import React from 'react';
import { Loader } from 'semantic-ui-react';
import Style from './totalcountLoader.module.css';
import { Numbers } from '@weezevent/nacre';
import i18n from 'i18next';

export default function CountTotalLoader({ loading, count, hasMore = false, children }) {
    const locale = i18n.language;

    return (
        <span className={Style['loader-count-container']} data-hasmore={hasMore}>
            {loading ? (
                <Loader className={Style['loader-count-loader']} active />
            ) : (
                <span className={Style['loader-count-value']}>
                    <Numbers value={count} locale={locale} />
                </span>
            )}
            <span className={Style['loader-count-label']}>{children}</span>
        </span>
    );
}
